module.exports = __webpack_public_path__ + "img/7.62142a09.png";